import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//document
import document from "./document/reducer"

//User
import user from "./user/reducer"

//Role
import role from "./role/reducer"

//notification
import notification from "./notification/reducer"

//navigation
import navigation from "./navigation/reducer"

//profile
import centerProfile from "./profile/reducer"

//report
import report from "./report/reducer"

//Dashboard
import Dashboard from "./dashboard/reducer"

//Calendar
import calendar from "./calendar/reducer"

//Module
import module from "./module/reducer"

//Helper
import helper from "./helper/reducer"

//subscription
import subscription from "./subscription/reducer"

//Project
import project from "./project/reducer"

//Zoom
import zoom from "./zoom/reducer"

//Healthday
import healthday from "./healthday/reducer"

const appReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  role,
  document,
  user,
  notification,
  navigation,
  centerProfile,
  report,
  Dashboard,
  user,
  calendar,
  module,
  helper,
  subscription,
  zoom,
  project,
  healthday,
})

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_USER") {
    // Reset the whole state
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer
